<div class="mat-dialog-container">
  <div class="dialog-content">
    <div class="dialog-close">
      <a mat-mini-fab (click)="close()">
        <mat-icon aria-label="Close Icon" class="close-icon">close</mat-icon>
      </a>
    </div>
    <p>{{data.title}}</p>
    <img src="assets/pop-up-image.png" alt="Phone Image">
    <div class="sms-options">
      <button mat-button (click)="updateUserSelection('Y')">Opt In</button>
      <button mat-button (click)="updateUserSelection('N')">Opt Out</button>
    </div>
  </div>
</div>
